import { useCallback } from "react";
import { MenuItem, Stack, TextField } from "@mui/material";
import { useNode } from "@craftjs/core";
import Map, { INITIAL_LOCATION, MAPTYPE } from "@/components/map/Map";
import useOrganizations from "@/features/organizations/useOrganizations";

export interface MapProps {
  latitude: number;
  longitude: number;
  type: MAPTYPE | string;
}

const MapSettings = () => {
  const {
    actions: { setProp },
    propValue: { latitude, longitude, type },
  } = useNode((node) => ({ propValue: node.data.props }));

  const { currentOrganization } = useOrganizations();

  const loadMap = useCallback(
    (map: any, maps: any) => {
      const position = {
        lat: currentOrganization.latitude ?? latitude ?? INITIAL_LOCATION.lat,
        lng: currentOrganization.longitude ?? longitude ?? INITIAL_LOCATION.lng,
      };
      const marker = new maps.Marker({
        position,
        map,
        draggable: true,
      });
      marker.addListener("dragend", () => {
        const newLatitude = marker.AdvancedMarkerElement.getPosition().lat();
        const newLongitude = marker.AdvancedMarkerElement.getPosition().lng();

        setProp((props: MapProps) => {
          props.latitude = newLatitude;
          props.longitude = newLongitude;
        });
      });
    },
    [currentOrganization.latitude, currentOrganization.longitude, latitude, longitude, setProp]
  );

  return (
    <Stack spacing={2}>
      <Map
        height="200px"
        googleApiLoaded={({ map, maps }) => loadMap(map, maps)}
        type={MAPTYPE.ROADMAP}
        defaultCenter={{
          lat: currentOrganization.latitude ?? latitude,
          lng: currentOrganization.longitude ?? longitude,
        }}
        defaultZoom={12}
      />
      <Stack>
        <TextField
          select
          size="small"
          label="Tipo de vista"
          name="map-type"
          value={type ?? MAPTYPE.ROADMAP}
          onChange={(e) => {
            setProp((props: MapProps) => {
              props.type = e.target.value;
              return props;
            });
          }}
        >
          <MenuItem value={MAPTYPE.ROADMAP}> Mapa </MenuItem>
          <MenuItem value={MAPTYPE.HYBRID}> Satelital </MenuItem>
        </TextField>
      </Stack>
      {/* <TextField
        label="Latitud"
        name="latitude"
        value={latitude ?? INITIAL_LOCATION.lat}
        onChange={(e) => {
          setProp((props: MapProps) => {
            props.latitude = Number(e.target.value);
            return props;
          });
        }}
        fullWidth
        size="small"
        margin="normal"
      />
      <TextField
        label="Longitud"
        name="longitude"
        value={longitude ?? INITIAL_LOCATION.lng}
        onChange={(e) => {
          setProp((props: MapProps) => {
            props.longitude = Number(e.target.value);
            return props;
          });
        }}
        fullWidth
        size="small"
        margin="normal"
      /> */}
    </Stack>
  );
};

export default MapSettings;
